import { createAsyncThunk } from '@reduxjs/toolkit';

import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ApiPaths } from '../../../api/APIPaths';
import { ISubject } from '.';

const apiDataProvider = new APIDataProvider();

export const getSubjects = createAsyncThunk('/subject/list', async () => {
  const response = await apiDataProvider.get<TApiResponse<ISubject[]>>(
    ApiPaths.subjects
  );

  return response.data;
});

export default getSubjects;
